module.exports = {
      id: "bondhushava-usage",
      viewBox: "0 0 225 61",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#bondhushava",
      toString: function () {
        return this.url;
      }
    }